"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _ms = _interopRequireDefault(require("ms"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _newAdministrator = _interopRequireDefault(require("./new-administrator"));
var _administratorsHelp = _interopRequireDefault(require("./administrators-help"));
var _deleteButton = _interopRequireDefault(require("../../../../core/delete-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_administratorsHelp.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "Those logged on using a listed email address will be able to set-up this competition and manage the entries.");
var _ref3 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Current Administrators"), /*#__PURE__*/_react.default.createElement("th", null, "Name"), /*#__PURE__*/_react.default.createElement("th", null, "Note"), /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null)));
class Administrators extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getDateOfSetupEmail", administrator => {
      if (!administrator.setupEmailSent) return '';
      return new Date(administrator.setupEmailSent).toISOString().split('T')[0];
    });
    _defineProperty(this, "_canSendEmail", administrator => {
      const today = new Date().toISOString().split('T')[0];
      return this._getDateOfSetupEmail(administrator) === today;
    });
    _defineProperty(this, "_getEmailSentText", administrator => {
      const sentDate = this._getDateOfSetupEmail(administrator);
      if (!sentDate) return null;
      return 'Copy of Setup Email Sent ' + (0, _occasion.default)(sentDate, 'D MMMM YYYY');
    });
  }
  render() {
    const comp = this.props.competition;
    if (!comp.isAdministratedByUser) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, _ref2, /*#__PURE__*/_react.default.createElement(_newAdministrator.default, {
      competitionID: comp.id
    }), /*#__PURE__*/_react.default.createElement(_table.default, null, _ref3, /*#__PURE__*/_react.default.createElement("tbody", null, comp.competitionAdministrators.map(administrator => /*#__PURE__*/_react.default.createElement("tr", {
      key: administrator.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      size: "sm",
      onClick: this.props.onDelete.bind(this.props, administrator.id)
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, administrator.administratorEmail), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      name: "notes",
      value: administrator.administratorName,
      maxLength: 100,
      onChange: this.props.onUpdate.bind(this.props, administrator.id, 'administratorName')
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      name: "notes",
      value: administrator.notes,
      maxLength: 200,
      onChange: this.props.onUpdate.bind(this.props, administrator.id, 'notes')
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this.props.resendOrganiserEmail.bind(this.props, administrator.id),
      disabled: this._canSendEmail(administrator)
    }, "Copy Setup Email")), /*#__PURE__*/_react.default.createElement("td", null, this._getEmailSentText(administrator)))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  id: true,
  isAdministratedByUser: true,
  competitionAdministrators: {
    id: true,
    administratorEmail: true,
    administratorName: true,
    notes: true,
    setupEmailSent: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(Administrators, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref4
}), (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('CompetitionAdministrator.set', {
      id,
      field,
      value
    });
  },
  onDelete(id) {
    return client.update('CompetitionAdministrator.delete', {
      id
    });
  },
  resendOrganiserEmail(id) {
    return client.update('CompetitionAdministrator.resendOrganiserEmail', {
      id
    });
  }
}));